import { mmFetchWithResponse } from './mmFetchWithResponse';

const receivingApi = {
    getReceivablePackaging: async (facilityID) => {
        const url = `api/receiving/v1/packaging?facilityID=${facilityID}`;
        return mmFetchWithResponse(url);
    },
    getReceivablePurchaseOrders: async (facilityID) => {
        const url = `api/receiving/v1/purchaseOrder?facilityID=${facilityID}`;
        return mmFetchWithResponse(url);
    },
    getReceivableGroceryAndPackagingPurchaseOrders: async (facilityID, includeReceived = false, poID = null) => {
        let url = `api/receiving/v2/purchaseOrder?facilityID=${facilityID}&includeReceived=${includeReceived}`;
        if (poID) {
            url += `&purchaseOrderId=${poID}`;
        }
        return mmFetchWithResponse(url);
    },
    getReceivedGroceryAndPackagingPurchaseOrders: async (facilityID) => {
        const url = `api/receiving/v2/receivedPurchaseOrder?facilityID=${facilityID}`;
        return mmFetchWithResponse(url);
    },
    receivePackaging: async (item) => {
        const url = `api/receiving/v1/packaging/${item.poID}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
    },
    receivePurchaseOrder: async (item) => {
        const url = `api/receiving/v1/purchaseOrder/${item.poID}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
    },
    receivePurchaseOrderWithPalletCounts: async (poID, sendData) => {
        const url = `api/receiving/v2/purchaseOrder/${poID}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendData),
        });
    },
    receivePackagingPurchaseOrderWithPalletCounts: async (poID, sendData) => {
        const url = `api/receiving/v2/packagingPO/${poID}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendData),
        });
    },
    receiveLineItemWithPalletCounts: async ({
        overrideExpirationDateBadgeNumber,
        pallets,
        poMapID,
        receiveQty0,
        uniqueExpirationDates,
    }) => {
        const url = `api/receiving/v2/purchaseOrder/lineItem/${poMapID}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({
                pallets,
                receiveQty0,
                uniqueExpirationDates,
                overrideExpirationDateBadgeNumber,
            }),
        });
    },
    receiveNetSuiteLineItem: async ({ pallets, poMapID, receiveQty0 }) => {
        const url = `api/receiving/v2/purchaseOrder/netsuiteLineItem/${poMapID}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({
                pallets,
                receiveQty0,
            }),
        });
    },
    receiveNetSuitePackagingItem: async ({ pallets, poMapID, receiveQty0 }) => {
        const url = `api/packagingreceivingsync/v1/packagingPurchaseOrderMap/netsuiteLineItem/${poMapID}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({
                pallets,
                receiveQty0,
            }),
        });
    },
    receiveTrucks: async ({ poMapID }) => {
        const url = `api/receiving/v2/purchaseOrder/receiveTrucks/${poMapID}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
        });
    },
    receivePackagingLineItemWithPalletCounts: async ({ pallets, poMapID, receiveQty0 }) => {
        const url = `api/receiving/v2/packagingPO/lineItem/${poMapID}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({
                pallets,
                receiveQty0,
            }),
        });
    },
    getPurchaseOrderReceivingProgress: async (poID, type) => {
        const url = `api/receiving/v2/purchaseOrder/progress?poID=${poID}&type=${type}`;
        return mmFetchWithResponse(url);
    },
    getLotsFromPoMapId: async (poMapId, type) => {
        const url = `api/receiving/v2/purchaseOrder/lots?${
            type === 'PACKAGING' ? 'packagingPoMapId' : 'poMapId'
        }=${poMapId}`;
        return mmFetchWithResponse(url);
    },
    getLotsFromPoMapGroupId: async (groupId, type) => {
        const url =
            type === 'PACKAGING'
                ? `api/warehouse/v2/receiving/packagingPurchaseOrderMapGroups/${groupId}/lots`
                : `api/warehouse/v2/receiving/purchaseOrderMapGroups/${groupId}/lots`;
        return mmFetchWithResponse(url);
    },
    saveUnitsPerCaseOverride: async (poMapID, receivedUnitsPerCase) => {
        const url = `api/receiving/v2/packagingPO/lineItem/${poMapID}/unitsPerCase`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ receivedUnitsPerCase }),
        });
    },
    saveUnitsPerCaseOverrideForGroup: async (packagingPurchaseOrderMapGroupId, receivedUnitsPerCase) => {
        const url = `api/warehouse/v2/receiving/packagingPurchaseOrderMapGroups/${packagingPurchaseOrderMapGroupId}/unitsPerCase`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ receivedUnitsPerCase }),
        });
    },
    getPurchaseOrderMapGroups: async (purchaseOrderId) => {
        const url = `api/warehouse/v2/receiving/purchaseOrder/${purchaseOrderId}/groups`;
        return mmFetchWithResponse(url);
    },
    getPackagingPurchaseOrderMapGroups: async (packagingPurchaseOrderId) => {
        const url = `api/warehouse/v2/receiving/packagingPurchaseOrder/${packagingPurchaseOrderId}/groups`;
        return mmFetchWithResponse(url);
    },
    receivePurchaseOrderMapGroup: async (purchaseOrderMapGroupId, body) => {
        const url = `api/warehouse/v2/receiving/purchaseOrderMapGroups/${purchaseOrderMapGroupId}/receive`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(body),
        });
    },
    receivePackagingPurchaseOrderMapGroup: async (packagingPurchaseOrderMapGroupId, body) => {
        const url = `api/warehouse/v2/receiving/packagingPurchaseOrderMapGroups/${packagingPurchaseOrderMapGroupId}/receive`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(body),
        });
    },
};

export { receivingApi };
